import { Argv } from 'yargs';

export function setupYarnAddToYargs<T extends any>(yargs: Argv<T>, opts: {
	allowEmptyName?: boolean,
} = {})
{
	return yargs
		.option('dev', {
			alias: 'D',
			desc: `install packages to devDependencies.`,
			boolean: true,
		})
		.option('peer', {
			alias: 'P',
			desc: `install packages to peerDependencies.`,
			boolean: true,
		})
		.option('optional', {
			alias: 'O',
			desc: `install packages to optionalDependencies.`,
			boolean: true,
		})
		.option('exact', {
			alias: 'E',
			desc: `see https://yarnpkg.com/lang/en/docs/cli/add/`,
			boolean: true,
		})
		.option('tilde', {
			alias: 'T',
			desc: `see https://yarnpkg.com/lang/en/docs/cli/add/`,
			boolean: true,
		})
		.option('audit', {
			desc: `see https://yarnpkg.com/lang/en/docs/cli/add/`,
			boolean: true,
		})
		.option('dedupe', {
			alias: ['d'],
			desc: `Data deduplication for yarn.lock`,
			boolean: true,
			default: true,
		})
		.option('ignore-workspace-root-check', {
			alias: ['W'],
			desc: `see https://yarnpkg.com/lang/en/docs/cli/add/`,
			boolean: true,
		})
		.option('types', {
			alias: ['type'],
			desc: `try auto install @types/* too`,
			boolean: true,
		})
}
